const actionTypes = require('constants/contactCenter/actionTypes');
const apiURLBuilder = require('core/apiURLBuilder');
const { APIPost } = require('utilities/APIRequestHelper');
const signaturePatternActions = require('actions/signaturePattern');
// @ constants
const {
    FIRST_STEP,
    WIZARD_FIRST_STEP,
    WIZARD_SECOND_STEP,
    // WIZARD_THIRD_STEP,
} = require('constants/index');

const reset = () => ({
    type:actionTypes.CHANGE_RECEIPT_ACCOUNT_RESET
})

const sendRequest = () => ({
    type: actionTypes.CHANGE_RECEIPT_ACCOUNT_REQUEST
});

const setVisibleStep = step => ({
    type: actionTypes.CHANGE_RECEIPT_ACCOUNT_SET_VISIBLE_STEP,
    payload: {
        step
    }
});

const changeReceiptAccountConfSuccess = () => ({
    type: actionTypes.CHANGE_RECEIPT_ACCOUNT_SUCCESS
});

const changeReceiptAccountConfFailure = (error) => ({
    type: actionTypes.CHANGE_RECEIPT_ACCOUNT_FAILURE,
    payload: {
        error
    }
});

const changeReceiptAccountConf = function( dispatch, getState, dataToken) {
    const {
        changeReceiptAccount,
        accounts,
        accountDebits
    } = getState();
    const destinationAccountIdPath = ['steps', FIRST_STEP, 'destinationAccountId'];

    const destinationAccountId = changeReceiptAccount.getIn(destinationAccountIdPath);
    const account = accounts.getIn(['byId', destinationAccountId]);

    const currentAccountIdPath = ['steps', FIRST_STEP, 'currentAccountId'];
    const currentAccountId = changeReceiptAccount.getIn(currentAccountIdPath);

    const receiptNumberPath = ['steps', FIRST_STEP, 'receiptNumber'];
    const receiptNumber = changeReceiptAccount.getIn(receiptNumberPath);

    const codAlfaNumGau = accountDebits.getIn([currentAccountId, 'byId', receiptNumber, 'tipauto']);
    const codInternoGau = accountDebits.getIn([currentAccountId, 'byId', receiptNumber, 'cdinaut']);
    const origenFondosGau = 'CTA';

    const requestData = {
        query: {
            codAlfaNumGau,
            codInternoGau,
            dataToken,
            numeroDeContrato: account.get('contractNumber'),
            origenFondosGau,
            producto: account.get('product'),
        }
    };

    dispatch(sendRequest());
    return APIPost(dispatch, apiURLBuilder.getURL('changeReceiptAccountConfirm') , requestData)
        .then(response => dispatch(changeReceiptAccountConfSuccess(response)))
        .catch(response => dispatch(changeReceiptAccountConfFailure(response)))

};

const requestSignaturePatternValidation = () => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        changeReceiptAccountConf(dispatch, getState, dataToken);
    };
    signaturePatternActions.validateAndExecute(dispatch, getState, callback);
};

const finish = () => dispatch => {
    dispatch(requestSignaturePatternValidation());
};

const validateUIStep = step => ({
    type: actionTypes.CHANGE_RECEIPT_ACCOUNT_VALIDATE_UI_STEP,
    payload: {
        step
    }
});

const setDestinationAccountIdValue = accountId => ({
    type: actionTypes.CHANGE_RECEIPT_ACCOUNT_SET_DESTINATION_ACCOUNT_ID,
    payload: {
        accountId
    }
});

const setDestinationAccountId = accountId => (dispatch) => {
    dispatch(setDestinationAccountIdValue(accountId));
    dispatch(validateUIStep(FIRST_STEP));
}

const setCurrentAccountId = accountId => ({
    type: actionTypes.CHANGE_RECEIPT_ACCOUNT_SET_CURRENT_ACCOUNT_ID,
    payload: {
        accountId
    }
});

const setReceiptNumber = receiptNumber => ({
    type: actionTypes.CHANGE_RECEIPT_ACCOUNT_SET_RECEIPT,
    payload: {
        receiptNumber
    }
});

const validateStep = step => (dispatch, getState) => {
    dispatch(validateUIStep(step));
    switch(step) {
        case WIZARD_FIRST_STEP:
            if (getState().changeReceiptAccount.getIn(['steps', FIRST_STEP, 'valid'])) {
                dispatch(setVisibleStep(WIZARD_SECOND_STEP));
            }
            break;
        case WIZARD_SECOND_STEP:
            dispatch(finish());
            break;
    }
};

const setWillCancel = willCancel => ({
    type: actionTypes.CHANGE_RECEIPT_ACCOUNT_WILL_CANCEL,
    payload: {
        willCancel
    }
});

const showCancelModal = (show) => ({
    type: actionTypes.CHANGE_RECEIPT_ACCOUNT_SHOW_CANCEL_MODAL,
    payload: {
        show
    }
});

module.exports = {
    reset,
    setVisibleStep,
    validateStep,
    validateUIStep,
    setWillCancel,
    changeReceiptAccountConf,
    changeReceiptAccountConfSuccess,
    changeReceiptAccountConfFailure,
    finish,
    setDestinationAccountId,
    setCurrentAccountId,
    setReceiptNumber,
    showCancelModal,
}
